import { Link } from 'react-router-dom'
import { Server, Zap } from 'lucide-react'
import { PageMeta } from '../components/seo/PageMeta'
import { pageMeta } from '../lib/seo'
import { servicesSchema } from '../lib/schema'

export default function Services() {
  return (
    <>
      <PageMeta
        title={pageMeta.services.title}
        description={pageMeta.services.description}
        canonical={pageMeta.services.canonical}
        schema={servicesSchema}
      />
      <main className="min-h-screen pt-24 pb-16 px-6">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h1 className="font-display font-black text-4xl md:text-5xl uppercase text-white mb-4">
            Two services. One partner.
          </h1>
          <p className="font-body text-cream-dim text-lg">
            Everything your business needs to run, compete, and grow.
          </p>
        </div>
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
          <Link
            to="/services/managed-it"
            className="p-10 rounded-lg border-2 block transition-all hover:border-accent"
            style={{ backgroundColor: 'var(--bg-3)', borderColor: 'var(--accent-line)' }}
          >
            <Server className="w-14 h-14 mb-6" style={{ color: 'var(--accent)' }} />
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">Managed IT</h2>
            <p className="font-body text-cream-dim mb-6">
              Full outsourced IT department. 24/7 monitoring, unlimited support, cloud migration, device management, security patching.
            </p>
            <span className="font-body font-medium" style={{ color: 'var(--accent)' }}>
              Learn More →
            </span>
          </Link>
          <Link
            to="/services/ai-automation"
            className="p-10 rounded-lg border-2 block transition-all hover:border-accent"
            style={{ backgroundColor: 'var(--bg-3)', borderColor: 'var(--accent-line)' }}
          >
            <Zap className="w-14 h-14 mb-6" style={{ color: 'var(--accent)' }} />
            <h2 className="font-display font-bold text-2xl uppercase text-white mb-3">AI Automation</h2>
            <p className="font-body text-cream-dim mb-6">
              Workflow automation, AI tool implementation, process audits, ROI tracking. We eliminate manual tasks that drain team time.
            </p>
            <span className="font-body font-medium" style={{ color: 'var(--accent)' }}>
              Learn More →
            </span>
          </Link>
        </div>
      </main>
    </>
  )
}
